<div class="content-block">
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 class="content-block">Dashboard Articolo</h2>
        <div class="d-flex gap-4">
          <dx-button stylingMode="contained" class="mr-3" text="Modifica articolo" icon="edit" type="success"
            (onClick)="goToArticoloEdit()"> </dx-button>
          <dx-button stylingMode="outlined" text="Nuova consegna articolo" icon="plus" type="normal"
            (onClick)="goToNuovaconsegna()"> </dx-button>



        </div>
      </div>
    </div>
  </div>
  <!-- Row cards principali -->
  <div class="row mb-3">
    <div class="col-12 col-lg-6">

      <div class="card p-4 h-80 shadow-sm border">
        <div class="d-flex align-items-center">

          <div class="flex-grow-1">
            <h2 class="card-title mb-3" style="margin-top:0">
              {{ articolo?.descrizione }}
              @if(articolo){
              <span id="empStatusBadgeAttivo" class="badge ms-2"
                [style.background-color]="articolo?.attivo ? '#28a745' : '#dc3545'"
                style="margin-left:10px; color: #fff;">
                {{articolo?.attivo ? 'Attivo' : 'Non attivo'}}
              </span>
              }
            </h2>

          </div>
        </div>

        <dl class="row mb-0">
          <dt class="col-3 col-md-3 fw-semibold">Codice:</dt>
          <dd class="col-9 col-md-9">{{articolo?.codice}}</dd>

          <dt class="col-3 col-md-3 fw-semibold">Tipologia:</dt>
          <dd class="col-9 col-md-9">{{tipoArticoloDescr}}</dd>

          <dt class="col-3 col-md-3 fw-semibold">Identificativo:</dt>
          <dd class="col-9 col-md-9">{{articolo?.identificativo ?? '-'}}</dd>

          <dt class="col-3 col-md-3 fw-semibold">Giorni alla scadenza:</dt>
          <dd class="col-9 col-md-9">
            @if(articolo?.scadenza){
            <span>
              {{ articolo.scadenza }} giorni
            </span>
            }
            @if(!articolo?.scadenza){
            <span>0</span>
            }
          </dd>

          <dt class="col-3 col-md-3 fw-semibold">Scorta minima:</dt>
          <dd class="col-9 col-md-9">{{articolo?.scortaMinima ?? '---'}}</dd>

          <dt class="col-3 col-md-3 fw-semibold">Note:</dt>
          <dd class="col-9 col-md-9">{{articolo?.note}}</dd>
        </dl>

      </div>


    </div>

    <div class="col-6 col-md-3 col-lg-2">
      <div class="card text-center p-3 border-4" style="border-width: 3px; min-height: 250px; overflow:auto;" [class]="{
                  'border-success': articolo?.giacenza >= (articolo?.scortaMinima ?? 0),
                  'border-warning': articolo?.giacenza < (articolo?.scortaMinima ?? 0) && articolo?.giacenza > 0,
                  'border-danger': articolo?.giacenza <= 0
                }">

        <div class="card-body">
          <h2 class="card-subtitle mb-2 text-muted font-weight-bold" style="font-size: 1.8em;">Giacenza disponibile</h2>

          <div id="stockAvailable" class="highlight-number" [class]="{
                      'text-success': articolo?.giacenza >= (articolo?.scortaMinima ?? 0),
                      'text-warning': articolo?.giacenza < (articolo?.scortaMinima ?? 0) && articolo?.giacenza > 0,
                      'text-danger': articolo?.giacenza <= 0
                    }">
            {{ articolo?.giacenza }}
          </div>

          <div class="mini text-muted">unità disponibili</div>
        </div>
      </div>
    </div>


    <div class="col-6 col-md-3 col-lg-2">
      <div class="card text-center p-3 border-4" style="border-width: 3px; min-height: 250px; overflow:auto;"
        [class]="{'border-warning' :numConsegneProssimeAllaScadenza > 0, 'border-normal': numConsegneProssimeAllaScadenza <= 0}">
        <div class="card-body">
          <h2 class="card-subtitle mb-2 text-muted font-weight-bold" style="font-size: 1.8em;">Prossimi alla scadenza
          </h2>
          <div id="usersNearExpiry" class="highlight-number "
            [class]="{'text-warning' :numConsegneProssimeAllaScadenza > 0, 'text-muted': numConsegneProssimeAllaScadenza <= 0}">
            {{numConsegneProssimeAllaScadenza}}</div>
          <div class="mini text-muted">dipendenti (entro {{giorniPreAlertArticoli}} gg)</div>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-12 col-lg-2">
      <div class="card text-center p-3 border-4" style="border-width: 3px; min-height: 250px; overflow:auto;"
        [class]="{'border-danger' :numConsegneScadute > 0, 'border-normal': numConsegneScadute <= 0}">
        <div class="card-body">
          <h2 class="card-subtitle mb-2 text-muted font-weight-bold" style="font-size: 1.8em;">Consegne scadute</h2>
          <div id="usersExpired" class="highlight-number"
            [class]="{'text-danger' :numConsegneScadute > 0, 'text-muted': numConsegneScadute <= 0}">
            {{numConsegneScadute}}</div>
          <div class="mini text-muted">dipendenti con articoli scaduti</div>
        </div>
      </div>
    </div>
  </div>


  <!-- Grafico e filtri -->
  <div class="row mb-3">
    <div class="col-12 col-lg-8">
      <div class="card p-3">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h3 class="card-title mb-0 font-weight-bold"></h3>
          <div class="d-flex gap-2 align-items-center">
            <dx-number-box #numberBox [showSpinButtons]="true" (onValueChanged)="ricaricaDati()"
              [(value)]="annoElaborazione" [min]="1999"></dx-number-box>
            <!--
              Da data <dx-date-box displayFormat="dd/MM/yyyy"  [(value)]="daData" (onValueChanged)="loadGiancenzeProgressive()" width="130px" style="margin-right: 20px;"> </dx-date-box>
              A data <dx-date-box  displayFormat="dd/MM/yyyy"  [(value)]="aData" (onValueChanged)="loadGiancenzeProgressive()" width="130px"> </dx-date-box>
            -->
          </div>
        </div>

        <div class="table-responsive" style="max-height:400px;  min-height: 400px; overflow:auto;">
          <!-- <app-chart-andamento-giacenza-articolo [idArticolo]="idArticolo" [giacenzeProgressive]="giacenzeProgressive"></app-chart-andamento-giacenza-articolo>        
          -->
          <app-chart-bar-consumi-mensili-articolo
            [consegneMensili]="consegneMensili"></app-chart-bar-consumi-mensili-articolo>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-4">
      <div class="card p-3 h-100">
        <h3 class="card-title font-weight-bold">Ultime consegne</h3>
        <div class="table-responsive" style="max-height:400px;  min-height: 400px; overflow:auto;">
          <app-grid-consegne-compact [idArticolo]="idArticolo"></app-grid-consegne-compact>
        </div>
      </div>
    </div>
  </div>

  <!-- Consegne prossime alla scadenza o scadute -->
  <div class="row  mb-3">
    <div class="col-12 col-lg-8">
      <div class="card p-3">
        <h3 class="card-title mb-3 font-weight-bold">Consegne prossime alla scadenza o scadute</h3>
        <div class="table-responsive" style="min-height: 150px; overflow:auto;">
          <app-articoli-consegnati-scadenze-compact [listConsegneAlert]="listConsegneAlert"
            [idArticolo]="idArticolo"></app-articoli-consegnati-scadenze-compact>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="card p-3">
        <h3 class="card-title mb-3 font-weight-bold">Altre scadenze</h3>
        <div class="table-responsive" style="min-height: 150px; overflow:auto;">
          <app-grid-scadenze-articoli-compact [idArticolo]="idArticolo"></app-grid-scadenze-articoli-compact>
        </div>
      </div>
    </div>
  </div>

</div>